import React, { Component } from 'react';
//import LikeButton from "./likebtn";
//import LikeButton from './components/likebtn';

class Posts extends React.Component {
    constructor(props) {
        super(props);
        super();
        this.state = {
            value: 'Pizza Social Media: Make a post about pizza.',
            likebutton: "Like",
            comment: 'Comment',
        };


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange2 = this.handleChange2.bind(this);
        this.handleSubmit2 = this.handleSubmit2.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    handleChange2(event) {
        this.setState({comment: event.target.comment});
    }



    handleSubmit(event) {
        alert('A new  post was made: ' + this.state.value);
        event.preventDefault();
    }

    handleSubmit2(event) {
        alert('New Comment' + this.state.comment);
        event.preventDefault();
    }

    likethepost=()=> {
        this.setState({likebutton: "Liked"});
    }




    render() {
        return (
            [
            <form onSubmit={this.handleSubmit}>
                <label>
                    New Pizza Post:
                    <textarea value={this.state.value} onChange={this.handleChange} />
                </label>
                <input type="submit" value="Submit" />
            </form>,




                <div onClick={this.handleChange}>

                    <h1>{this.state.value} - Delete</h1>

                </div>,

                <div onClick={this.likethepost}>
                    <div>{this.likebutton}</div>
                    <h1>{this.state.likebutton}</h1>
                </div>,

                <form onSubmit={this.handleSubmit2}>
                    <label>
                        Comment on this post:
                        <textarea value={this.state.comment} onChange={this.handleChange2} />
                    </label>
                    <input type="submit" value="Submit" />
                </form>,

                <div onClick={this.handleChange2}>

                    <h1>{this.state.comment}</h1>

                </div>,





            ]


        );
    }
}

export default Posts;